import { createRouter, createWebHistory } from 'vue-router';
import FileUpload from '../components/FileUpload.vue';
import FolderTree from '../components/FolderTree.vue';
import TokenList from '../components/TokenList.vue';

const routes = [
  {
    path: '/upload',
    name: 'FileUpload',
    component: FileUpload,
  },
  {
    path: '/folder-tree',
    name: 'FolderTree',
    component: FolderTree,
  },
  {
    path: '/tokens',
    name: 'TokenList',
    component: TokenList,
  },
  {
    path: '/',
    redirect: '/upload',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
      next('/');
  } else {
      next();
  }
});

export default router;
